import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for generating tokens with filters.
 * @extends JetView
 */
export default class FilterGenerateTokenView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Configuration for the left section containing a date picker
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Make the input read-only
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Configuration for the right center section (currently empty)
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Configuration for the right section (currently empty)
        const right = {
            margin: 5,
            rows: [],
        };

        // Upper section layout combining left, center, and right sections
        const upper_section = {
            cols: [
                { gravity: 0, minWidth: 10 },
                center_left,
                { gravity: 0, minWidth: 10 },
                center_right,
                { gravity: 0, minWidth: 10 },
                right,
            ],
        };

        // Configuration for action buttons
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to generate token
                    value: _('Generar Token'),
                    autowidth: true,
                    click: () => {
                        const cur_user = this.getParam('user', true); // Get current user ID
                        const filterdata = this.getRoot().getValues(); // Get form values
                        var thisClich = this; // Reference to the current context
                        webix
                            .ajax() // AJAX request to save user security
                            .headers({
                                'Content-type': 'application/json',
                            })
                            .post(
                                devConfig.geturlApi() + // API URL from config
                                    '/UserManagement/SaveUserSecurity',
                                '{ "UserId":' + cur_user + '}', // Payload with user ID
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_('Error')); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text); // Parse response
                                        webix.message(_('Guardado')); // Show success message
                                        thisClich.app.callEvent(
                                            'generateToken:filter',
                                            [filterdata], // Trigger event with filter data
                                        );
                                    },
                                },
                            );
                    },
                },
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to consult/filter data
                    value: _('Consultar'),
                    hotkey: 'enter', // Assign enter key as hotkey
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('generateToken:filter', [
                            filterdata, // Trigger event with filter data
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
